import { Component, OnDestroy, OnInit } from "@angular/core"
import { BrowsingService } from "../../services/browsing.service"
import { CHNode } from "../../models/node.model"
import { Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"

@Component({
    selector: "app-subjects",
    templateUrl: "./subjects.component.html",
    styleUrls: ["./subjects.component.scss"],
    standalone: false,
})
export class SubjectsComponent implements OnInit, OnDestroy {
    subjects: CHNode[]
    public gtmPrefix: string = "gtm-browse-by-subject-"
    private destroyed$: Subject<void> = new Subject()

    constructor(private browsingService: BrowsingService) {}

    ngOnInit() {
        this.subscribeToActiveNodeChanges()
    }

    public subscribeToActiveNodeChanges(): void {
        this.browsingService.activeNodeChanged
            .pipe(
                takeUntil(this.destroyed$),
                tap((node: CHNode) => (this.subjects = node.children))
            )
            .subscribe()
    }

    ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
